module.exports = __webpack_public_path__ + "images/emoji/heart.6cdfd2968fdede065f60.png";